import { motion } from "framer-motion";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import {
  Mail,
  MessageCircle,
  Phone,
  ExternalLink,
} from "lucide-react";

export default function Contact() {
  return (
    <div className="min-h-screen bg-background">
      <NavBar />

      {/* Hero */}
      <section className="relative pt-32 pb-20">
        <div className="absolute inset-0 bg-gradient-to-br from-accent/5 via-transparent to-secondary/5" />
        <div className="absolute top-1/3 right-1/4 w-96 h-96 bg-accent/10 rounded-full blur-[150px]" />

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center max-w-3xl mx-auto"
          >
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-black mb-6">
              Get in <span className="text-primary">Touch</span>
            </h1>
            <p className="text-lg sm:text-xl text-muted-foreground">
              Have questions? We're here to help you on your passive income journey.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 relative">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Contact Options */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-2xl font-heading font-bold mb-8 text-center">
              Contact <span className="text-primary">Options</span>
            </h2>

            <div className="space-y-6">
              {/* Telegram */}
              <a
                href="https://t.me/passivepaycoin"
                target="_blank"
                rel="noopener noreferrer"
                className="glass-card rounded-xl p-6 flex items-center gap-4 hover:border-primary/30 transition-colors block"
              >
                <div className="w-12 h-12 rounded-xl bg-blue-500/20 flex items-center justify-center">
                  <MessageCircle className="w-6 h-6 text-blue-400" />
                </div>
                <div className="flex-1">
                  <div className="font-heading font-bold">Telegram</div>
                  <div className="text-sm text-muted-foreground">Join our community</div>
                </div>
                <ExternalLink className="w-5 h-5 text-muted-foreground" />
              </a>

              {/* WhatsApp */}
              <a
                href="https://wa.me/995511288844"
                target="_blank"
                rel="noopener noreferrer"
                className="glass-card rounded-xl p-6 flex items-center gap-4 hover:border-primary/30 transition-colors block"
              >
                <div className="w-12 h-12 rounded-xl bg-green-500/20 flex items-center justify-center">
                  <Phone className="w-6 h-6 text-green-400" />
                </div>
                <div className="flex-1">
                  <div className="font-heading font-bold">WhatsApp</div>
                  <div className="text-sm text-muted-foreground">Direct messaging</div>
                </div>
                <ExternalLink className="w-5 h-5 text-muted-foreground" />
              </a>

              {/* Email */}
              <a
                href="mailto:contact@passivepay.in"
                className="glass-card rounded-xl p-6 flex items-center gap-4 hover:border-primary/30 transition-colors block"
              >
                <div className="w-12 h-12 rounded-xl bg-primary/20 flex items-center justify-center">
                  <Mail className="w-6 h-6 text-primary" />
                </div>
                <div className="flex-1">
                  <div className="font-heading font-bold">Email</div>
                  <div className="text-sm text-muted-foreground">contact@passivepay.in</div>
                </div>
                <ExternalLink className="w-5 h-5 text-muted-foreground" />
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-12 relative">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="glass-card rounded-2xl p-8 border-primary/30"
          >
            <h3 className="text-xl font-heading font-bold mb-2">
              Start your <span className="text-primary">PassivePay</span> journey today.
            </h3>
            <p className="text-muted-foreground">
              Join our community and begin building your passive income.
            </p>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
